export const shouldLoad = () => document.querySelector('[data-controller="expandable"]') !== undefined;
